import { combineReducers } from 'redux';

import authenticate from './authenticate';
// import cockpit from './cockpit';
import user from './user';
import needRefresh from './needRefresh';
import chartData from './charts';

export default combineReducers({
	authenticate,
	// cockpit,
	user,
    needRefresh,
    chartData,
});
